import {
  faCalendar,
  faClock,
} from "@fortawesome/free-regular-svg-icons";
import { faBarcode, faMoneyBillWave } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState, useCallback } from "react";
import { useHistory } from "react-router-dom";
import {
  orderListDetailApi,
  OrderspreparedAPI,
} from "../../Api/SupplierServices";
import { separate } from "../../Functions/NumberSeprator";
import Factor from "../Factor/Factor";
import LoadingComponet from "../LoadingComponet/LoadingComponet";
import Modal from "../Modal/Modal";
import Style from "./OrdersPrepared.module.css";
import Timer from "../Timer/Timer";
import { splitJalaliDateTime } from "../../Functions/convertDateToJalali";
import { Receipt, GeoAlt, HourglassSplit, Bicycle } from "react-bootstrap-icons";

const OrdersPrepared = () => {
  const history = useHistory();
  const [purchased, setPurchased] = useState(false);
  const [orderList, setOrderList] = useState();
  const [orderListDetails, setOrderListDetails] = useState();
  const [orderID, setOrderID] = useState();

  const getOrderLists = useCallback(async () => {
    try {
      const data = await OrderspreparedAPI();
      setOrderList(data?.orders || []);
    } catch (err) {
      setOrderList([]);
    }
  }, []);

  useEffect(() => {
    getOrderLists();
  }, [getOrderLists]);

  const getOrderListsDetail = async (id) => {
    try {
      const data = await orderListDetailApi(id);
      setOrderListDetails(data);
    } catch (err) {
      setOrderListDetails({ products: [] });
    }
  };

  const FactorListHandler = (id) => {
    setOrderID(id);
    setOrderListDetails(undefined);
    setPurchased(true);
    getOrderListsDetail(id);
  };

  const deliverLocation = (orderId) => {
    history.push("/live", orderId);
  };

  let loadinghandler = null;
  if (orderList === undefined) {
    loadinghandler = <LoadingComponet />;
  } else if (orderList.length === 0) {
    loadinghandler = (
      <div className={Style.NotOrderFoundHolder}>
        <div className={Style.ImageBasket}>
          <img src="/Assets/Images/Order/emtyOreder.svg" alt="barest" />
        </div>
        <p className={Style.NoOrderText}>سفارش آماده‌شده‌ای یافت نشد</p>
      </div>
    );
  } else {
    const displayedOrders = Array.isArray(orderList) ? [...orderList].reverse() : [];
    loadinghandler = displayedOrders.map((item, index) => {
      const { date: orderDate, time: orderTime } = splitJalaliDateTime(item.date);
      return (
        <div key={item.id || index} className={Style.orderCard}>
          {/* Card Top: Date & Time + Timer */}
          <div className={Style.cardHeader}>
            <div className={Style.dateGroup}>
              <div className={Style.dateBadge}>
                <FontAwesomeIcon icon={faCalendar} />
                <span>{orderDate}</span>
              </div>
              <div className={Style.timeBadge}>
                <FontAwesomeIcon icon={faClock} />
                <span>{orderTime}</span>
              </div>
            </div>

            <div className={Style.timerWrapper}>
              <Timer Time={item.prepare_remaining_time} />
            </div>
          </div>

          {/* Card Body: Info Fields */}
          <div className={Style.cardBody}>
            <div className={Style.infoRow}>
              <span className={Style.infoLabel}>
                <FontAwesomeIcon icon={faBarcode} /> کد پیگیری:
              </span>
              <span className={Style.trackingCode}>{item.id}</span>
            </div>

            <div className={Style.infoRow}>
              <span className={Style.infoLabel}>
                <Bicycle /> کد تحویل به پیک:
              </span>
              <span className={Style.deliveryCodeBadge}>
                {item.delivery_code}
              </span>
            </div>

            <div className={Style.infoRow}>
              <span className={Style.infoLabel}>
                <FontAwesomeIcon icon={faMoneyBillWave} /> مبلغ کل:
              </span>
              <span className={Style.totalPrice}>
                {separate(item.cart)} تومان
              </span>
            </div>

            <div className={Style.infoRow}>
              <span className={Style.infoLabel}>
                <FontAwesomeIcon icon={faMoneyBillWave} /> کمیسیون:
              </span>
              <span className={Style.feePrice}>
                {separate(item.cart_fee)} تومان
              </span>
            </div>
          </div>

          {/* Card Actions */}
          <div className={Style.cardActions}>
            {item.status === "1" ? (
              <div className={Style.deliverWait}>
                <HourglassSplit style={{ marginLeft: "0.4rem" }} />
                <span>در انتظار تایید پیک</span>
              </div>
            ) : (
              <button
                type="button"
                className={Style.deliverLoc}
                onClick={() => deliverLocation(item.id)}
              >
                <GeoAlt className={Style.btnIcon} />
                <span>مکان پیک</span>
              </button>
            )}

            <button
              type="button"
              className={Style.factorListBtn}
              onClick={() => FactorListHandler(item.id)}
            >
              <Receipt className={Style.btnIcon} />
              <span>لیست سفارش</span>
            </button>
          </div>
        </div>
      );
    });
  }

  return (
    <div className={Style.ComponentHolder}>
      <Modal
        show={purchased}
        modalClose={() => setPurchased(false)}
        translate={40}
      >
        <Factor orderID={orderID} data={orderListDetails} />
      </Modal>

      <div className={Style.ordersGrid}>{loadinghandler}</div>
    </div>
  );
};

export default OrdersPrepared;
